import { WindEnemy } from './enemies/WindEnemy';
import { Engine } from "./Engine";
import { Enemy } from "./enemies/Enemy";
import { GameConstants } from "./GameConstants";
import { HealerEnemy } from "./enemies/HealerEnemy";

export class EnemiesSpawner {

    private engine: Engine;

    constructor (engine: Engine) {
        
        this.engine = engine;
    }

    public getEnemy(): Enemy {

        let enemy: Enemy = null;

        if (this.engine.waveEnemies.length > 0) {

            const nextEnemyData = this.engine.waveEnemies[0];
            
            if (nextEnemyData.t === this.engine.ticksCounter) {

                const path = this.engine.enemiesPathsCells[nextEnemyData.path].path;

                switch (nextEnemyData.type) {
                    case GameConstants.ENEMY_WATER:
                        enemy = new HealerEnemy(nextEnemyData.subtype, this.engine.ticksCounter, this.engine, path);
                        break;
                    case GameConstants.ENEMY_WIND:
                        enemy = new WindEnemy(nextEnemyData.subtype, this.engine.ticksCounter, this.engine, path);
                        break;
                    default:
                        enemy = new Enemy(nextEnemyData.type, nextEnemyData.subtype, this.engine.ticksCounter, this.engine, path);
                        break;
                }

                // cada ronda que pasa los enemigos tienen mas vida y mas valor
                enemy.maxLife = enemy.life;

                this.engine.waveEnemies.shift();
            }
        }

        return enemy;
    }

    public killAllWaveEnemies(): void {

        let enemy: Enemy;

        for (let i = 0; i < this.engine.waveEnemies.length; i++) {

            const enemyData = this.engine.waveEnemies[i];
            const path = this.engine.enemiesPathsCells[enemyData.path].path;

            switch (enemyData.type) {
                case GameConstants.ENEMY_WATER:
                    enemy = new HealerEnemy(enemyData.subtype, this.engine.ticksCounter, this.engine, path);
                    break;
                case GameConstants.ENEMY_WIND:
                    enemy = new WindEnemy(enemyData.subtype, this.engine.ticksCounter, this.engine, path);
                    break;
                default:
                    enemy = new Enemy(enemyData.type, enemyData.subtype, this.engine.ticksCounter, this.engine, path);
                    break;
            }

            enemy.killInstantly();
        }

        this.engine.waveEnemies.length = 0;
    }
}
